// BulkOperationsToolbar - Copy Week and Copy to Sections features removed
// This component is kept as a placeholder for future bulk operations

export function BulkOperationsToolbar(_props: {
  viewMode: 'class' | 'teacher' | 'subject';
  selectedEntity: string | null;
  selectedWeek: Date;
  selectedSections?: string[];
}) {
  return null;
}
